module.exports = __webpack_public_path__ + "assets/img/shop.024538ed.png";